// extracted by mini-css-extract-plugin
module.exports = {"feesSection":"styles_feesSection__fqgfI","feesSectionContainer":"styles_feesSectionContainer__TgkJX"};